export const TUTORIAL_SECTIONS = [
    { value: 'gerencial', label: 'Gerencial' },
    { value: 'operacional', label: 'Operacional' },
    { value: 'comercial', label: 'Comercial' },
    { value: 'financeiro', label: 'Financeiro' },
];

export const TUTORIAL_PAGES = [
    { value: 'dashboard', label: 'Dashboard', section: 'gerencial' },
    { value: 'calculator', label: 'Calculadora de preço', section: 'gerencial' },
    { value: 'printers', label: 'Lista de impressoras', section: 'operacional' },
    { value: 'jobs', label: 'Lista de impressões', section: 'operacional' },
    { value: 'printer_maintenances', label: 'Lista de manutenções', section: 'operacional' },
    { value: 'replacement_parts', label: 'Lista de peças de reposição', section: 'operacional' },
    { value: 'filaments', label: 'Lista de filamentos', section: 'operacional' },
    { value: 'products', label: 'Lista de produtos', section: 'comercial' },
    { value: 'customers', label: 'Lista de clientes', section: 'comercial' },
    { value: 'partners', label: 'Lista de parcerias', section: 'comercial' },
    { value: 'quick_checkout', label: 'Quick checkout', section: 'comercial' },
    { value: 'quotes', label: 'Lista de orçamentos', section: 'comercial' },
    { value: 'checkouts', label: 'Lista de checkout', section: 'comercial' },
    { value: 'orders', label: 'Lista de vendas', section: 'comercial' },
    { value: 'transactions', label: 'Lista de transações', section: 'financeiro' },
    { value: 'operational_costs', label: 'Lista de custos operacionais', section: 'financeiro' },
    { value: 'bank_reconciliation', label: 'Conciliação bancária', section: 'financeiro' },
];

export function tutorialSectionLabel(value) {
    return TUTORIAL_SECTIONS.find((item) => item.value === value)?.label || value || '—';
}

export function tutorialPageLabel(value) {
    return TUTORIAL_PAGES.find((item) => item.value === value)?.label || value || '—';
}

export function pagesForSection(section) {
    return TUTORIAL_PAGES.filter((item) => item.section === section);
}

/** Extrai o ID do YouTube a partir de watch/embed/youtu.be/shorts. */
export function extractYoutubeVideoId(rawUrl) {
    const value = String(rawUrl || '').trim();
    if (!value) {
        return '';
    }
    if (/^[a-zA-Z0-9_-]{11}$/.test(value)) {
        return value;
    }
    try {
        const url = new URL(value);
        const host = url.hostname.replace(/^www\./, '');
        if (host === 'youtu.be') {
            return url.pathname.split('/').filter(Boolean)[0] || '';
        }
        if (host.endsWith('youtube.com')) {
            const v = url.searchParams.get('v');
            if (v) {
                return v;
            }
            const parts = url.pathname.split('/').filter(Boolean);
            if (parts[0] === 'embed' || parts[0] === 'shorts' || parts[0] === 'live') {
                return parts[1] || '';
            }
        }
    } catch {
        return '';
    }
    return '';
}

export function youtubeEmbedUrl(videoIdOrUrl) {
    const id = extractYoutubeVideoId(videoIdOrUrl);
    return id ? `https://www.youtube.com/embed/${id}?rel=0` : '';
}

export function youtubeThumbnailUrl(videoIdOrUrl) {
    const id = extractYoutubeVideoId(videoIdOrUrl);
    return id ? `https://img.youtube.com/vi/${id}/mqdefault.jpg` : '';
}

export function resolveTutorialPlaybackUrl(video, preferMobile) {
    if (!video) {
        return '';
    }
    if (preferMobile && String(video.mobile_url || '').trim()) {
        return String(video.mobile_url).trim();
    }
    return String(video.desktop_url || '').trim();
}

export function groupTutorialsBySection(items) {
    const grouped = TUTORIAL_SECTIONS.map((section) => ({
        ...section,
        items: [],
    }));
    const byValue = Object.fromEntries(grouped.map((section) => [section.value, section]));
    (items || []).forEach((item) => {
        const bucket = byValue[item.section];
        if (bucket) {
            bucket.items.push(item);
        }
    });
    return grouped.filter((section) => section.items.length > 0);
}
